import React, { useEffect, useState } from "react";
import { Card, Row, Col, Image, Spinner } from "react-bootstrap";
import RainbowButton from "../shared/RainbowButton";
import { useData } from "../../providers/dataProvider";
import TeamSocials from "./TeamSocials";

export default function TeamTile({ member, reversed }) {
  const { name, position, description, image_id } = member;
  const { images, imagesLoading } = useData();

  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getImageUrl = async () => {
      if (image_id) {
        setLoading(true);
        try {
          const image = images.find((i) => i.id === image_id);
          setImageUrl(image.aws_location);
        } catch (error) {
          console.error("Error loading team member image:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    getImageUrl();
  }, [image_id, images]);

  return (
    <Card className="team-member-card">
      <Card.Body>
        <Row
          className={`align-items-center ${reversed ? "flex-row-reverse" : ""}`}
        >
          {/* Text Content */}
          <Col xs={12} sm={6} className="mt-3 mt-sm-0">
            <h3 className="team-member-name">{name}</h3>
            <h5 className="team-member-position">{position}</h5>
            <p className="team-member-description">{description}</p>
            <TeamSocials member={member} />
            <div className="mt-3">
              <RainbowButton
                text={`Book with ${name} Now`}
                href="https://styleemporium.glossgenius.com/booking-flow"
              />
            </div>
          </Col>

          {/* Image Column */}
          <Col xs={12} sm={6} className="order-first order-sm-last">
            {loading || imagesLoading ? (
              <div className="text-center py-5">
                <Spinner animation="border" className="team-member-spinner" />
              </div>
            ) : imageUrl ? (
              <Image
                src={imageUrl}
                alt={`Photo of ${name}`}
                fluid
                className="team-member-image"
              />
            ) : (
              <div className="team-member-image-placeholder">
                <p>No image available</p>
              </div>
            )}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}
